import React from "react";
import { Card, Col, Row, Select, Statistic } from "antd";
import SectionHeader from "./SectionHeader";
import { printform } from "../../../../../../../../utils/printforms";

const { Option } = Select;

// const REPORT_NAME = "preview";
const REPORT_NAME = "receipt";

/**
 * Section 1 — ภาพรวมลูกค้า (ระบบคำนวณอัตโนมัติ)
 *
 * @param {{
 *   isExpanded: boolean,
 *   onToggle: () => void,
 *   overview: object,
 *   onOverviewChange: (key: string, value: any) => void,
 * }} props
 */
const CustomerOverview = ({
  isExpanded,
  onToggle,
  overview,
  onOverviewChange,
  leadSourceOptions = [],
}) => (
  <>
    <SectionHeader
      title="ภาพรวมลูกค้า (ระบบคำนวณอัตโนมัติ)"
      isExpanded={isExpanded}
      onToggle={onToggle}
    />

    {isExpanded && (
      <Card
        size="small"
        className="mb-4"
        style={{
          background: "#fafafa",
          borderColor: "#e5e7eb",
          borderRadius: "8px",
        }}
        bodyStyle={{ padding: "16px" }}
      >
        {/* Row 1: 4 Statistic Cards */}
        <Row gutter={[12, 12]} className="mb-1">
          {[
            {
              label: "วันที่ซื้อครั้งแรก",
              sub: "First Purchase",
              value: overview.first_date,
            },
            {
              label: "วันที่ซื้อล่าสุด",
              sub: "Last Purchase",
              value: overview.last_date,
            },
            {
              label: "จำนวนคำสั่งซื้อ",
              sub: "Total Orders",
              value: overview.total_orders,
            },
            {
              label: "มูลค่าเฉลี่ย/ออเดอร์",
              sub: "AOV",
              value: overview.aov,
            },
          ].map(({ label, sub, value }) => (
            <Col span={6} key={label}>
              <Card
                size="small"
                bordered
                style={{ borderRadius: "6px", background: "#fff" }}
              >
                <Statistic
                  title={
                    <div style={{ fontSize: "11px", color: "#6b7280" }}>
                      {label}{" "}
                      <span style={{ fontSize: "10px", color: "#9ca3af" }}>
                        {sub}
                      </span>
                    </div>
                  }
                  value={value}
                  valueStyle={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#1f2937",
                  }}
                />
              </Card>
            </Col>
          ))}
        </Row>

        {/* Row 2: Product Table + Right Panel (LTV + Lead Source) */}
        <Row gutter={[16, 12]} className="mt-1 align-items-start">
          {/* Left: สินค้าบิลล่าสุด แบบตาราง */}
          <Col span={16}>
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                overflow: "hidden",
                background: "#fff",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "12px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#f9fafb",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <th
                      style={{
                        padding: "7px 12px",
                        color: "#4b5563",
                        fontWeight: "600",
                        textAlign: "left",
                        width: "60%",
                        borderRight: "1px solid #f0f0f0",
                      }}
                    >
                      <div>
                        สินค้าที่ซื้อตามบิลล่าสุด{" "}
                        <span
                          style={{
                            fontSize: "10px",
                            color: "#9ca3af",
                            fontWeight: "normal",
                          }}
                        >
                          ( Latest Bill Items )
                        </span>
                      </div>
                      {overview.last_document_no && (
                        <div style={{ marginTop: "2px" }}>
                          <span
                            style={{
                              color: "#1890ff",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontWeight: "normal",
                            }}
                            onClick={() =>
                              printform(REPORT_NAME, {
                                report_id: overview.last_document_report_id,
                              })
                            }
                          >
                            เลขที่ใบเสร็จ : {overview.last_document_no}
                          </span>
                        </div>
                      )}
                    </th>
                    <th
                      style={{
                        padding: "7px 12px",
                        color: "#4b5563",
                        fontWeight: "600",
                        textAlign: "left",
                      }}
                    >
                      หมวดหมู่สินค้า{" "}
                      <span
                        style={{
                          fontSize: "10px",
                          color: "#9ca3af",
                          fontWeight: "normal",
                        }}
                      >
                        ( Product Category )
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {overview.last_order_items?.length > 0 ? (
                    overview.last_order_items.map((item, i, arr) => (
                      <tr
                        key={i}
                        style={
                          i < arr.length - 1
                            ? { borderBottom: "1px solid #f0f0f0" }
                            : {}
                        }
                      >
                        <td
                          style={{
                            padding: "7px 12px",
                            color: "#1f2937",
                            fontWeight: "500",
                            borderRight: "1px solid #f0f0f0",
                          }}
                        >
                          {item.product_name || "-"}
                        </td>
                        <td style={{ padding: "7px 12px", color: "#6b7280" }}>
                          {item.category?.map((c) => c.name).join(", ") || "-"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          padding: "10px 12px",
                          color: "#9ca3af",
                          textAlign: "center",
                        }}
                      >
                        ไม่มีข้อมูลรายการสินค้า
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>

          {/* Right: LTV Card + Lead Source */}
          <Col span={8}>
            {/* LTV */}
            <Card
              size="small"
              bordered
              style={{
                borderRadius: "6px",
                background: "#fff",
                marginBottom: "8px",
              }}
            >
              <Statistic
                title={
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                    มูลค่าสะสม{" "}
                    <span style={{ fontSize: "10px", color: "#9ca3af" }}>
                      LTV - Lifetime Value
                    </span>
                  </div>
                }
                value={overview.ltv}
                valueStyle={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              />
            </Card>

            {/* Lead Source */}
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "12px 14px",
                background: "#fff",
              }}
            >
              <div
                style={{
                  fontSize: "11px",
                  color: "#4b5563",
                  fontWeight: "600",
                  marginBottom: "6px",
                }}
              >
                ช่องทางที่รู้จัก{" "}
                <span
                  style={{
                    fontSize: "10px",
                    color: "#9ca3af",
                    fontWeight: "normal",
                  }}
                >
                  Lead Source
                </span>
              </div>
              <Select
                value={overview.lead_source}
                onChange={(val) => onOverviewChange("lead_source", val)}
                style={{ width: "100%" }}
              >
                {leadSourceOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
      </Card>
    )}
  </>
);

export default CustomerOverview;
